// extracted by mini-css-extract-plugin
export default {"text":"BillingWasteWeightInput_text__JGhAu","container":"BillingWasteWeightInput_container__oic7M"};